// https://github.com/tldraw/tldraw/blob/828848f8af110772486f086946fab97ff8775fe6/packages/editor/src/lib/utils/reordering/reordering.ts#L0-L1
import { generateNKeysBetween } from "./dgreensp";
/**
 * Get a number of indices between two indices.
 * @param below - The index below.
 * @param above - The index above.
 * @param n - The number of indices to get.
 * @public
 */ export function getIndicesBetween(below, above, n) {
    return generateNKeysBetween(below, above, n);
}
/**
 * Get a number of indices above an index.
 * @param below - The index below.
 * @param n - The number of indices to get.
 * @public
 */ export function getIndicesAbove(below, n) {
    return generateNKeysBetween(below, undefined, n);
}
/**
 * Get a number of indices below an index.
 * @param above - The index above.
 * @param n - The number of indices to get.
 * @public
 */ export function getIndicesBelow(above, n) {
    return generateNKeysBetween(undefined, above, n);
}
/**
 * Get the index between two indices.
 * @param below - The index below.
 * @param above - The index above.
 * @public
 */ export function getIndexBetween(below, above) {
    return generateNKeysBetween(below, above, 1)[0];
}
/**
 * Get the index above a given index.
 * @param below - The index below.
 * @public
 */ export function getIndexAbove(below) {
    return generateNKeysBetween(below, undefined, 1)[0];
}
/**
 * Get the index below a given index.
 * @param above - The index above.
 *  @public
 */ export function getIndexBelow(above) {
    return generateNKeysBetween(undefined, above, 1)[0];
}
/**
 * Get n number of indices, starting at an index.
 * @param n - The number of indices to get.
 * @param start -  The index to start at.
 * @public
 */ export function getIndices(n, start = "a1") {
    return [
        start,
        ...generateNKeysBetween(start, undefined, n)
    ];
}
/**
 * Sort by index.
 * @param a - An object with an index property.
 * @param b - An object with an index property.
 * @public */ export function sortByIndex(a, b) {
    if (a.index < b.index) {
        return -1;
    } else if (a.index > b.index) {
        return 1;
    }
    return 0;
}
